import { ATTACHMENT_BOUNDARY_PATH_PREFIX } from "../../common/constants";

export const DOCUMENT_NODE_ROUTE_PREFIX = "/documents";

export const DOCUMENT_NODE_ROUTE_PATHS = {
  list: { path: "*", to: DOCUMENT_NODE_ROUTE_PREFIX },
  attachment: { to: `${ATTACHMENT_BOUNDARY_PATH_PREFIX}${DOCUMENT_NODE_ROUTE_PREFIX}/:id` },
};
